import { useState, useEffect } from 'react';

export default function ProtectedImage({ 
  src, 
  alt, 
  className = '',
}) {
  const [loaded, setLoaded] = useState(false);

  const handleContextMenu = (e) => {
    e.preventDefault();
    alert('This artwork is protected by copyright. \u00a9 Scott McGuire / mortalworks.art');
    return false;
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  // Block keyboard shortcuts for saving/copying
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey && e.key === 's') ||
        (e.ctrlKey && e.key === 'p') ||
        (e.ctrlKey && e.shiftKey && e.key === 'i') ||
        (e.key === 'PrintScreen')
      ) {
        e.preventDefault();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div 
      className="relative protected-wrapper screenshot-guard"
      onContextMenu={handleContextMenu}
    >
      {!loaded && (
        <div className={`skeleton ${className}`} />
      )}
      
      <img
        src={src}
        alt={alt}
        className={`${className} ${loaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        draggable="false"
        onDragStart={handleDragStart}
        onLoad={() => setLoaded(true)}
        style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
      />
      
      {/* Transparent overlay to prevent saving/dragging */}
      <div 
        className="absolute inset-0 bg-transparent" 
        style={{ pointerEvents: 'all' }}
        onContextMenu={handleContextMenu}
      />
    </div>
  );
}
